import React,{Component} from 'react';
import {Row} from 'react-bootstrap';
import cssClasses from './Record.css'
import Pizzicato from 'pizzicato'
import PizzicatoRecorder from 'pizzicato-recorder'

class Record extends Component {
    state = {
        isRecording:false
    }
    
    constructor(props){
        super(props);
        PizzicatoRecorder(Pizzicato);
    }
    recordingClickHandler = () =>{

        // start recording
        if(!this.state.isRecording){
            Pizzicato.Recorder.start({ mute: false })
            this.setState({
                isRecording:true
            })
        }
        else{ //stop recording
            Pizzicato.Recorder.stop('wav', this.handleAudio);
            this.setState({
                isRecording:false
            })
        }
    }

    handleAudio(file,fileType){
        let url = URL.createObjectURL(file)
        let hf = document.createElement('a')
        hf.href = url
        hf.download = 'dj-mix.' + fileType
        hf.innerHTML = hf.download
        hf.click()
    }

    render(){

        let recordText = this.state.isRecording ? 'SAVE' : 'REC'

        let recordStyles = [cssClasses.RecordButton];
        if(this.state.isRecording){
            recordStyles.push(cssClasses.isRecording);
        }
        return (
            <Row className={cssClasses.Record}>
                {/* <Col className={cssClasses.Col}>
                </Col> */}
                <div className={cssClasses.RecordDiv}>
                    <div className={recordStyles.join(" ")} onClick={this.recordingClickHandler}></div>
                    <div className={cssClasses.RecordText}>{recordText}</div>
                </div>
            </Row>
        );
    }

}

export default Record;